"use client";

import Image from "next/image";

const defaultImages = [
  {
    id: 1,
    src: "/images/playground/ocr_example.jpeg",
    alt: "OCR Example",
  },
  {
    id: 2,
    src: "/images/playground/wines.jpg",
    alt: "Wines",
  },
  {
    id: 3,
    src: "/images/playground/burger.jpg",
    alt: "Burger",
  },
  {
    id: 4,
    src: "/images/playground/cuttingboard.jpg",
    alt: "Cutting board",
  },
  {
    id: 5,
    src: "/images/playground/delorean.jpg",
    alt: "Delorean",
  },
  {
    id: 6,
    src: "/images/playground/manufacturing.jpg",
    alt: "Manufacturing",
  },
  {
    id: 7,
    src: "/images/passport_example.jpeg",
    alt: "Passport",
  },
  {
    id: 8,
    src: "/images/robbery_example.jpeg",
    alt: "Security",
  },
  {
    id: 9,
    src: "/images/broken_box.jpeg",
    alt: "Damaged Box",
  },
  {
    id: 10,
    src: "/images/playground/defect_example.jpeg",
    alt: "Surface Defect",
  },
];

interface SampleImagesProps {
  images?: string[];
  onImageSelect: (imageSrc: string) => void;
}

export default function SampleImages({ images = [], onImageSelect }: SampleImagesProps) {
  // Use provided images or fall back to default images
  const imagesToShow = images.length > 0 ? images.map((src, index) => ({
    id: index + 1,
    src,
    alt: `Sample image ${index + 1}`
  })) : defaultImages;
  return (
    <div className="flex flex-wrap gap-2 mt-4">
      <h3 className="w-full text-sm font-medium mb-2">Sample Images</h3>
      {imagesToShow.map((image) => (
        <button
          key={image.id}
          className="w-18 h-18 rounded-md overflow-hidden"
          onClick={() => onImageSelect(image.src)}
          type="button"
        >
          <Image
            src={image.src}
            alt={image.alt}
            width={96}
            height={96}
            className="object-cover w-full h-full grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300 hover:cursor-pointer"
          />
        </button>
      ))}
    </div>
  );
}
